import { http, createConfig } from 'wagmi';
import { mainnet, sepolia } from 'wagmi/chains';
import { coinbaseWallet, injected, walletConnect } from 'wagmi/connectors';
import { mainnetRpcUrl } from '@/constants/network';

// wagmi v2の型定義では、chainsとtransportsの型が厳格に一致する必要があります
// 実行時には1つのチェーンのみを使用しますが、型安全性のため両方のチェーンを定義します

// Fast Refresh時のWalletConnect複数初期化を防ぐため、
// globalにconfigを保持（開発環境のみ）
declare global {
  // eslint-disable-next-line no-var
  var __wagmiConfig: ReturnType<typeof createConfig> | undefined;
}

const createWagmiConfig = () =>
  createConfig({
    chains: [mainnet, sepolia],
    connectors: [
      injected(), // MetaMask用（v2では injected() を使用）
      walletConnect({
        projectId: process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID || '',
        showQrModal: true,
        qrModalOptions: {
          themeVariables: {
            '--wcm-z-index': '1500',
          },
        },
      }),
      coinbaseWallet({
        appName: 'Slash Vision Portal',
      }),
    ],
    transports: {
      [mainnet.id]: http(mainnetRpcUrl),
      [sepolia.id]: http('https://rpc2.sepolia.org'),
    },
  });

export const wagmiConfig =
  globalThis.__wagmiConfig ?? (globalThis.__wagmiConfig = createWagmiConfig());
